import Rest from "Utils/Rest";

import UserSecurityQuestions from "Models/Security/UserSecurityQuestionsModel";

export default class SecurityService {
    lockBrowser = () => {
        return Rest.POST<any>("Security/LockBrowser", {});
    }

    checkAuthenticationAndSessionState = () => {
        return Rest.POST<any>("Security/CheckAuthenticationAndSessionState", {});
    }

    checkLogin = (checkPassword: boolean, ignoreLock: boolean, password: string, username: string, checkAuthAndSession: boolean, encFacilityId: string) => {
        return Rest.POST<any>("Security/CheckLogin", {
            checkPassword: checkPassword,
            ignoreLock: ignoreLock,
            password: password,
            username: username,
            checkAuthAndSession: checkAuthAndSession,
            encFacilityId: encFacilityId
        });
    }

    logoutUser = (isTimeout?: boolean) => {
        return Rest.POST<any>("Security/LogoutUser", { isTimeout: isTimeout });
    }

    switchFacility = (encFacilityId: string) => {
        return Rest.POST<any>("Security/SwitchFacility", { encFacilityId: encFacilityId });
    }

    getUserSecurityQuestions = () => {
        return Rest.GET<UserSecurityQuestions>("Security/UserSecurityQuestions", {});
    }

    saveUserSecurityQuestions = (questions: UserSecurityQuestions) => {
        return Rest.POST<any>("Security/UserSecurityQuestions", questions);
    }

    changePassword = (oldPassword: string, newPassword: string) => {
        return Rest.POST<any>("Security/ChangePassword", { oldPassword: oldPassword, newPassword: newPassword });
    }

    meaningfulUseConfiguration = () => {
        return Rest.GET<any>("Security/MeaningfulUseConfiguration", {});
    }

    keepSessionAlive = () => {
        return Rest.GET<boolean>("Security/KeepSessionAlive", {});
    }

    isIdpUser = () => {
        return Rest.GET<boolean>("Security/IsIdpUser", {});
    }
}
